// extracted by mini-css-extract-plugin
module.exports = {"card":"AssetTable_card__MC6pv","cardBody":"AssetTable_cardBody__QkCzk"};